// extracted by mini-css-extract-plugin
export default {"box":"ContactForm_box__ss18H","form":"ContactForm_form__F1OAi"};